import { useDeleteDataMutation, useGetData } from "@/services";
import { MasterModuleLayout, useMasterModule } from "../Common";

const BillingCategory = () => {
  const masterHook = useMasterModule({
    queryKey: "billing-categories",
    idKey: "billingCategoryId",
    nameKey: "categoryName",
    useGetDataQuery: useGetData,
    useToggleStatusMutation: useDeleteDataMutation,
    isDeleteFn: true,
    module: "billing-categories",
    statusSuccessMessage: "Billing Category Deleted Successfully",
    enableRowView: true,
  });

  return <MasterModuleLayout title="Billing Category" hookResult={masterHook} />;
};

export default BillingCategory;
